import axios, {AxiosResponse} from "axios";
import {axiosInstance} from "../utils/axiosInstance";
import type {AllComments, AllCommentsFilter, AllCommentsResponse} from "./types/comments";

const mainEndpoint = 'admin/comments'

export async function fetchAllComments(searchParams: AllCommentsFilter): Promise<AxiosResponse<AllCommentsResponse>> {
    return await axiosInstance.get(mainEndpoint, {params: {...searchParams, page_size: 10000}});
}

export async function approveCommentRequest(id): Promise<> {
    const endpoint = `/${id}`
    return await axiosInstance.patch(`${mainEndpoint}${endpoint}`, {is_verified: true})
}

export async function disApproveCommentRequest(id): Promise<> {
    const endpoint = `/${id}`
    return await axiosInstance.patch(`${mainEndpoint}${endpoint}`, {is_verified: false})
}

export async function deleteCommentRequest(id): Promise<> {
    const endpoint = `/${id}`
    return await axiosInstance.delete(`${mainEndpoint}${endpoint}`)
}

export async function replyToCommentRequest(parentId: number, newsId: number, content: string) {
    const endpoint = `comments`
    return await axiosInstance.post(endpoint, {parent: parentId, news: newsId, content: content})
}
